var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"copy","size":"lg"},on:{"click":function($event){$event.stopPropagation();return _vm.copyQuiz()}}})}
var staticRenderFns = []

export { render, staticRenderFns }